import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Grid, Button } from '@material-ui/core';
import BackIcon from '@material-ui/icons/KeyboardArrowLeft';
import classNames from 'classnames';
import MessageListCmp from '../MessageListCmp/MessageListCmp.js';
import MessageInfoCmp from '../MessageInfoCmp/MessageInfoCmp.js';
import { getAllMessage } from '../../actions/MessageScreen/index.js';

import PropTypes from 'prop-types';

class MessageScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            switchToMessageInfo: false,
            selectedMessageId: '',
            selectedMessageData: {},
            classes: PropTypes.object.isRequired
        }

        if (this.props.match
                && this.props.match.params.type === 'messages'
                && this.props.match.params.id) {
            // messageId exist; switch mode to individual message view
            this.state.switchToMessageInfo = true;
            this.state.selectedMessageId = this.props.match.params.id;
        } else {
            // otherwise fetch all
            this.props.getAllMessage();
        }
    }

    handleMessageClick = (messageId) => {
        this.props.history.push(`/dash/messages/${messageId}`);
        this.goToMessageInfo(messageId);
    }

    handleBackButton() {
        this.props.getAllMessage();
        this.props.history.push(`/dash/messages`);
        this.setState({ selectedMessageId: '', switchToMessageInfo: false });
    }

    goToMessageInfo = (messageId) => {
        this.setState({ selectedMessageId: messageId, switchToMessageInfo: true });
    }

    render() {
        return (
            <Grid container direction="column">
                <Grid container item justify="center" style={{height: 50, marginTop: 20}}>
                    <Grid item xs={10} md={8}>
                        {
                            this.state.selectedMessageId && this.state.switchToMessageInfo&&
                                <Button onClick={this.handleBackButton.bind(this)} color="primary" variant="outlined" size="medium" className={this.state.classes.button} style={{ marginBottom: 25 }}>
                                    <BackIcon className={classNames(this.state.classes.leftIcon, this.state.classes.iconSmall)} />
                                    Back to Message List
                                </Button>
                        }
                    </Grid>
                </Grid>
                <Grid container item>
                    <Grid item container justify="center">
                        <Grid container item xs={12} md={8}>
                            {
                                !this.state.switchToMessageInfo &&
                                <MessageListCmp
                                    messages={this.props.messageScreenStates.messages}
                                    handleMessageClick={this.handleMessageClick.bind(this)}
                                />
                            }
                            {
                                this.state.switchToMessageInfo &&
                                <MessageInfoCmp messageId={this.state.selectedMessageId} />
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        messageScreenStates: state.messageScreenStates
    };
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        getAllMessage,
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(MessageScreen));
